import React, { Component } from "react";

import { Container, Row, Col, Table, Form, Alert, Button, Badge } from "react-bootstrap";

import CommonDataTableLoading from '../components/CommonDataTableLoading';
import CommonRowId from '../components/CommonRowId';
import CommonRecordNotFound from '../components/CommonRecordsNotFound';
import CommonPagination from '../components/CommonPagination';

import CommonToast from '../components/CommonToast';
import CommonConfirmModal from '../components/CommonConfirmModal';
import CommonAlert from '../components/CommonAlert';

import CommonInput from '../components/CommonInput';
import CommonSelect from '../components/CommonSelect';
import CommonButton from '../components/CommonButton';
import CommonDropdown from '../components/CommonDropdown';
import CommonFile from '../components/CommonFile';
import CustomDatePicker from "../components/CommonDatePicker";
import CommonCheckbox from '../components/CommonCheckbox';
import CommonRadio from '../components/CommonRadio';

import CommonLoadingBar from '../components/CommonLoadingBar';

import CommonTokenExpired from '../components/CommonTokenExpired';

import * as constants from '../../config/constants/AppConstants';

import * as Actions from '../actions/ActionCenter';

import * as fn from '../../library/function';
import * as helper from '../../library/helper';
import * as util from '../../library/utilitys';

import { GlobalStates } from '../states/GlobalStates';

/** individual page state */
import { PageDataState } from '../states/EB05DataSatisfactionAssessmentState';

/** requester handle */
import requester from "../../library/Requester"; 

import { OptionsConstants as options } from '../../config/constants/OptionsConstants';

/** define end point */
const TABLE = `satisfaction_assessment_eb_05`;
const URL = `api/master/${TABLE}`;

const PARENT = 'training_details_enterprise_eb_03_id';

class InlineSatisfactionAssessmentEB05 extends Component {

    constructor(props){
        super(props);

        this.state = {...GlobalStates, ...PageDataState};
        this.updateState = this.setState.bind(this);

        this.inlineInputRowRef = React.createRef();
    }    

    initialize = async () => {
        let {refKey, refPage, fkId, fkVal} = this.props;

        await Actions.parametersInline(this.updateState, PARENT, {id: fkId, value: fkVal, key: refKey, page: refPage});

        if (fkId && fkVal) {
            await this.loadMasterbase();
            await this.setDefaultInputs();
        }
    }      

    loadMasterbase = async () => {  
        let { Inputs } = this.state;
        let sets = [
            { key: "training_details_enterprise_eb_03_lists", filter: [{ field: 'id', value: Inputs.training_details_enterprise_eb_03_id.value }]}, 
            { key: "satisfaction_assessment_eb_05", filter: [{ field: 'training_details_enterprise_eb_03_id', value: Inputs.training_details_enterprise_eb_03_id.value }]},                        
        ]; 
        
        await Actions.loadMasterbase(this.updateState, sets);
    }  

    setDefaultInputs = async () => {
        await Actions.setDefaultInputs(this.updateState, PARENT, async () => {

            let { Inputs, Masterbase } = this.state;
            
            const eb05 = (Array.isArray(Masterbase?.satisfaction_assessment_eb_05) && Masterbase.satisfaction_assessment_eb_05.length > 0)
            ? Masterbase.satisfaction_assessment_eb_05[0]
            : null;    
            
            if(!util.isEmpty(eb05?.id)){ 
                await this.fetchForEdit({id: eb05?.id});
            }
        });
    } 

    fetchForEdit = async (obj) => {
        await Actions.fetchForEdit(
            this.updateState,
            `${URL}/${obj.id}`, 
            {element: 'Inline', mode: 'update', bool: true}
        );        
    }    

    submitData = async () => {
        const { Action, Inputs, DataTable } = this.state; 
        await Actions.submitData(
            this.updateState,
            `${URL}`,
            Action.Mode, 
            fn.getInputForm({...Inputs}),
            null,
            null,
            this.state.Inputs
        );
    }   
    
    deleteData = async () => {
        const { Deletes } = this.state;
        await Actions.deleteData(this.updateState, `${URL}`, Deletes, null);
        Actions.handleDiscardInputs(this.updateState, 'Inputs');
        this.setDefaultInputs();
    }
    
    componentDidMount = async () => { 
        await this.initialize();
    };

    componentDidUpdate = async (prevProps) => {
        if (prevProps.fkVal !== this.props.fkVal && !util.isEmpty(this.props.fkVal)) {
            await this.initialize();
        }        
    }    

    render = () => {
        
        let { Action, DataTable, Inputs, Masterbase, InputGroup, Deletes, Operation, Parameters, Token } = this.state;

        let { onDrillUpInline } = this.props;

        let { show, mode } = Action.Inline;

        let { Submit } = Operation;

        let isLoading = Action.Loading.submit;        

        const isFk = Parameters[PARENT]?.parameters?.element?.find(item => item.id === PARENT)?.value ?? null;

        const profile = (Array.isArray(Masterbase?.training_details_enterprise_eb_03_lists) && Masterbase.training_details_enterprise_eb_03_lists.length > 0)
            ? Masterbase.training_details_enterprise_eb_03_lists[0]
            : null;        

        return (
            <Container fluid className="data-table-container" style={{border: '1px solid #EEE', borderRadius: '8px', padding: '4px'}}>

                <CommonTokenExpired Token={Token} />

                <CommonToast 
                    toast={Action.Toast} 
                    onCloseToast={(e) => Actions.handleCloseToast(this.updateState)}
                /> 

                <CommonConfirmModal 
                    Action={Action}
                    Deletes={Deletes}

                    onCallback={async (e) => { 
                        let result = await Actions.handleControlModal(this.updateState, e);
                        if(result.action){
                            if (result.section === 'Delete'){ await this.deleteData(); }
                        }
                    }}
                />

                {profile?.enterprise_name && (
                    <>
                        <Row className="mt-3">
                            <Col md={12}>
                                <div className="d-flex justify-content-between align-items-center mb-2 ms-2 me-2">
                                    <h5 className="mb-0 d-flex align-items-center gap-2">
                                        <Badge bg="primary" pill>{`สถานประกอบการที่เข้าร่วมอบรม รุ่นที่ : ${profile?.model_no}`}</Badge>
                                        <Badge bg="info" pill>{`สถานประกอบการ : ${profile?.enterprise_name}`}</Badge>
                                    </h5>

                                    <CommonButton 
                                        task="back" 
                                        rounded={true}
                                        disabled={false}
                                        callback={(e) => onDrillUpInline({ key: 'satisfaction_assessment_eb_05' })}
                                    />
                                </div>
                            </Col>
                        </Row>

                        <Row className="mt-3">
                            <Col md={12} className="d-flex align-items-center justify-content-center text-center">
                                <h6>แบบประเมินความพึงพอใจคุณภาพของหลักสูตร (EB 05)</h6>
                            </Col>
                        </Row>  

                        <Row className="mt-3">
                            <Col md={2} className="mb-3"></Col>
                            <Col md={1} className="mb-3">{util.formatLabel('ตำแหน่งของผู้ประเมิน', '', '', 'sm')}</Col>   
                            <Col md={2} className="mb-3">
                                <CommonInput
                                    element="Inputs"
                                    input={Inputs.evaluator}
                                    size="sm"
                                    hr={false}
                                    floatingLabel={false}
                                    callback={(e, element) =>  Actions.handleInputChange(this.updateState, element, e)} 
                                />    
                            </Col>
                        </Row> 
                        <Row className="mt-3">
                            <Col md={2} className="mb-3"></Col>
                            <Col md={5} className="mb-3">{util.formatLabel('ค่าใช้จ่ายที่สถานประกอบการลงทุน (ร้อยละ ๕0 ในการอบรมครั้งนี้ (เพื่อเป็นข้อมูลในการลดหย่อนภาษี) เป็นจำนวนทั้งสิ้น)', '', '', 'sm')}</Col> 
                            <Col md={1} className="mb-3">
                                <CommonInput
                                    element="Inputs"
                                    input={Inputs.employer_investment}
                                    size="sm"
                                    hr={false}
                                    floatingLabel={false}
                                    callback={(e, element) =>  Actions.handleInputChange(this.updateState, element, e)} 
                                />    
                            </Col>
                             <Col md={1} className="mb-3"><font className="label-size-sm">บาท</font></Col>                            
                        </Row>  

                        <Row className="mt-3">
                            <Col md={12} className="mb-3 text-center"><b className="label-size-sm">แบบสอบถามประเมินความพึงพอใจของหลักสูตร</b></Col>
                        </Row>      

                        <Row className="mt-3">
                              <Col md={{ span: 8, offset: 2 }}>

                                    <Row>
                                        <Col md={12}>
                                            <p className="text-muted" style={{ fontSize: '0.85rem', lineHeight: '1.8' }}>
                                                <b>ระดับความพึงพอใจ</b><br />
                                                5 ระดับมากที่สุด หมายถึง ความพึงพอใจต่อคุณภาพของหลักสูตรในระดับมากที่สุด<br />
                                                4 ระดับมาก หมายถึง ความพึงพอใจต่อคุณภาพของหลักสูตรในระดับมาก<br />
                                                3 ระดับปานกลาง หมายถึง ความพึงพอใจต่อคุณภาพของหลักสูตรในระดับปานกลาง<br />
                                                2 ระดับน้อย หมายถึง ความพึงพอใจต่อคุณภาพของหลักสูตรในระดับน้อย<br />
                                                1 ระดับน้อยที่สุด หมายถึง ความพึงพอใจต่อคุณภาพของหลักสูตรในระดับน้อยที่สุด
                                            </p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={12}><hr className="hr-custom" /></Col>
                                    </Row>  

                                    <Row><Col md="12"><b className="label-size-sm" style={{color: '#000'}}>การดำเนินงานของหลักสูตรก่อนเริ่มการอบรม</b></Col></Row>
                                    <Row className="mt-3">
                                        <Col md={12}>
                                            <CommonRadio
                                                element="Inputs"
                                                input={Inputs.question_1}
                                                radio={InputGroup.Radio.question}
                                                size="sm"
                                                hr={false}
                                                callback={(e, element) => Actions.handleInputChange(this.updateState, element, e)} 
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mt-3">
                                        <Col md={12}>
                                            <CommonRadio
                                                element="Inputs"
                                                input={Inputs.question_2}
                                                radio={InputGroup.Radio.question}
                                                size="sm"
                                                hr={false}
                                                callback={(e, element) => Actions.handleInputChange(this.updateState, element, e)} 
                                            />
                                        </Col>
                                    </Row>  
                                    <Row className="mt-3">
                                        <Col md={12}>
                                            <CommonRadio
                                                element="Inputs"
                                                input={Inputs.question_3}
                                                radio={InputGroup.Radio.question}
                                                size="sm"
                                                hr={false}
                                                callback={(e, element) => Actions.handleInputChange(this.updateState, element, e)} 
                                            />
                                        </Col>
                                    </Row>   
                                    <Row className="mt-3">
                                        <Col md={12}>
                                            <CommonRadio
                                                element="Inputs"
                                                input={Inputs.question_4}
                                                radio={InputGroup.Radio.question}
                                                size="sm"
                                                hr={false}
                                                callback={(e, element) => Actions.handleInputChange(this.updateState, element, e)} 
                                            />
                                        </Col>
                                    </Row> 
                                    <Row className="mt-3">
                                        <Col md={12}>
                                            <CommonRadio
                                                element="Inputs"
                                                input={Inputs.question_5}
                                                radio={InputGroup.Radio.question}
                                                size="sm"
                                                hr={false}
                                                callback={(e, element) => Actions.handleInputChange(this.updateState, element, e)} 
                                            />
                                        </Col>
                                    </Row> 

                                    <Row className="mt-3"><Col md="12"><b className="label-size-sm" style={{color: '#000'}}>ผลการดำเนินงานของหลักสูตร</b></Col></Row>  
                                    <Row className="mt-3">
                                        <Col md={12}>
                                            <CommonRadio
                                                element="Inputs"
                                                input={Inputs.question_6}
                                                radio={InputGroup.Radio.question}
                                                size="sm"
                                                hr={false}
                                                callback={(e, element) => Actions.handleInputChange(this.updateState, element, e)} 
                                            />
                                        </Col>
                                    </Row>  
                                    <Row className="mt-3">
                                        <Col md={12}>
                                            <CommonRadio
                                                element="Inputs"
                                                input={Inputs.question_7}
                                                radio={InputGroup.Radio.question}
                                                size="sm"
                                                hr={false}
                                                callback={(e, element) => Actions.handleInputChange(this.updateState, element, e)} 
                                            />
                                        </Col>
                                    </Row>    
                                    <Row className="mt-3">
                                        <Col md={12}>
                                            <CommonRadio
                                                element="Inputs"
                                                input={Inputs.question_8}
                                                radio={InputGroup.Radio.question}
                                                size="sm"
                                                hr={false}
                                                callback={(e, element) => Actions.handleInputChange(this.updateState, element, e)} 
                                            />
                                        </Col>
                                    </Row>    
                                    <Row className="mt-3">
                                        <Col md={12}>
                                            <CommonRadio
                                                element="Inputs"
                                                input={Inputs.question_9}
                                                radio={InputGroup.Radio.question}
                                                size="sm"
                                                hr={false}
                                                callback={(e, element) => Actions.handleInputChange(this.updateState, element, e)} 
                                            />
                                        </Col>
                                    </Row> 
                                    <Row className="mt-3">
                                        <Col md={12}>
                                            <CommonRadio
                                                element="Inputs"
                                                input={Inputs.question_10}
                                                radio={InputGroup.Radio.question}
                                                size="sm"
                                                hr={false}
                                                callback={(e, element) => Actions.handleInputChange(this.updateState, element, e)} 
                                            />
                                        </Col>
                                    </Row>    
                                    <Row className="mt-3">
                                        <Col md={12}>
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.suggestions}
                                                size="sm"
                                                hr={false}
                                                callback={(e, element) => Actions.handleInputChange(this.updateState, element, e)}
                                                disabled={false}
                                                floatingLabel={false}
                                            />
                                        </Col>
                                    </Row> 

                                    <Row><Col md="12"><hr className="mt-0 mb-3"></hr></Col></Row>

                                    <Row>
                                        <Col md="12" className="mb-3">

                                            <CommonLoadingBar isLoading={isLoading} />

                                            <div className="d-flex justify-content-end mt-2">
                                                <CommonButton 
                                                    task={`${mode}`} 
                                                    disabled={isLoading ? true : Submit ? false : true}
                                                    callback={async (e) => await this.submitData() }
                                                /> 

                                                {!util.isEmpty(Inputs.id.value) && this.state.childRowCount === 0 && (                                        
                                                    <CommonButton 
                                                        task="delete-no-text" 
                                                        inlineClass="ms-1 me-2" 
                                                        callback={async (e) => { 
                                                            Actions.handleDataTableToggleDelete(this.updateState, {target: {checked : true, value: Inputs.id.value} })
                                                            Actions.handleControlModal(this.updateState, {mode: 'confirm-delete', show: true, action: false});
                                                        }}
                                                    />
                                                )}
                                            </div>                            
                                        </Col>
                                    </Row>                                                                                                                                                                                                                                                                                                                                                                                                

                              </Col>
                        </Row>                                                                
                       
                    </>
                )}
            </Container>
        )
    }
}

export default InlineSatisfactionAssessmentEB05;